import '../styles/main.scss'
import 'focus-visible'
import app from './app.js'

document.addEventListener('DOMContentLoaded', () => {
  app.mount()
})
